import { render, staticRenderFns } from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=template&id=6611baf3&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoSocioambientalModal.vue?vue&type=style&index=0&id=6611baf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611baf3",
  null
  
)

export default component.exports